import {COMPLIANCE_OPTIONS, type ComplianceCodeName} from 'bigdatr-style';

export const complianceShortlistQueryKeys = {
    review: (complianceCodeId: string, creativeId: string) =>
        ['compliance-creative-review', complianceCodeId, creativeId] as const
};

export function resolveComplianceCode(
    complianceCode: string | undefined,
    permitted: readonly ComplianceCodeName[]
): ComplianceCodeName {
    const fallback = permitted[0] ?? COMPLIANCE_OPTIONS[0];
    return permitted.find((option) => option === complianceCode) ?? fallback;
}
